module.exports = __webpack_public_path__ + "b3b75544b740e711919a2efc2b4b0fdb.pdf";